import React from "react";
import Container from "../../components/Container";
import { MarkdownStyle } from "../../components/markdown/Markdown";
import { Link } from "react-router-dom";
import BackButton from "../../components/form/BackButton";

export default function Hermes() {
    return (
        <>
            <div className="hermes-background flex h-48 w-full items-center justify-center">
                <h1 className="text-4xl font-black uppercase text-white lg:text-6xl">Hermesgent</h1>
            </div>

            <Container variant={"small"} className="relative">
                <div className="absolute -top-16 right-2 w-32 rounded-full border-2 bg-white p-8 dark:bg-slate-800 md:right-0">
                    <img src="/images/hermes_logo.svg" alt="" />
                </div>
            </Container>
            <Container variant={"small"} className="mt-16">
                <MarkdownStyle className="mx-auto max-w-full">
                    <BackButton />
                    <p>
                        During my time as a student at the University of Ghent, I became acquainted with the student group associated with my academic discipline. Intrigued, I became a member of this group, and within a year, I embarked on my journey as an ICT enthusiast. This volunteer role
                        involved revamping the student group's websites.
                    </p>
                    <p>Although the student group had an existing website, it had fallen behind the times. This prompted the concept of crafting a brand-new digital platform. Remarkably, the website I contributed to is still actively utilized by the student group to this day.</p>
                    <Link target="_BLANK" to="https://hermesgent.be">
                        Visit website
                    </Link>
                </MarkdownStyle>
            </Container>
        </>
    );
}
